// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_jgT","cls2":"AuthorHeader-cls2_PbF AuthorHeader-cls1_jgT"};